(ns teamoesterreich.admin-mode.ui-helper.line-edit-card
  (:require-macros [toe-prepare.cljstemplates :refer [deftmpl]])
  (:require
    [teamoesterreich.util.helper :as h] ;;(h/event-value e)
    [reagent.core :as r]
    [reagent-material-ui.components :as mui]
    [teamoesterreich.util.log :as log]

    [reagent-material-ui.icons.info :refer [info]]
    [reagent-material-ui.icons.save :refer [save]]
    [reagent-material-ui.icons.edit :refer [edit]]
    [reagent-material-ui.icons.close :refer [close]]
    [reagent-material-ui.icons.arrow-right :refer [arrow-right]]
    [reagent-material-ui.icons.arrow-drop-down :refer [arrow-drop-down]]
    [reagent-material-ui.icons.keyboard-arrow-left :refer [keyboard-arrow-left]]
    ))






(defn get-it [content on-save-fn & [title]]
  (let [!st (r/atom {:editor-content content :edit-mode false})
        !editor-mode (r/cursor !st [:edit-mode])
        !editor-content (r/cursor !st [:editor-content])]

    (fn []
      (let [line-ch? (not= content @!editor-content)]
        [mui/card
         (when title
           [mui/card-header {:title title}])
         [mui/card-content
          {:style {:width "800px" :textAlign "left"}}

          [mui/text-field {
                           :style        {:backgroundColor (if line-ch? "#ffd6d2" "#ffffff")}
                           :fullWidth    true
                           :disabled     (not @!editor-mode)
                           :label        "Text"
                           :onChange     (fn [e] (reset! !editor-content (h/event-value e)))
                           :defaultValue content
                           }]]

         [mui/card-actions
          {:style {:marginTop "15px"}}
          (if @!editor-mode
            [mui/button {:variant   "contained"
                         :startIcon (r/as-element [keyboard-arrow-left])
                         :onClick   #(swap! !st assoc :editor-content content :edit-mode false)
                         }
             "Abbrechen"]
            [mui/button {:variant   "contained"
                         :startIcon (r/as-element [edit])
                         :onClick   #(reset! !editor-mode true)
                         }
             "Bearbeiten"])

          (when @!editor-mode
            [mui/button {:variant   "contained"
                         :startIcon (r/as-element [save])
                         :color "primary"
                         :onClick   (fn []
                                      (on-save-fn @!editor-content)
                                      (swap! !st assoc :editor-content content :edit-mode false))
                         }
             "Speichern"])

          ]

         ]
        )


      )))